<template>

  <b-row>
    <b-col>
      <b-card
        style="margin:0;border:1px solid #2980b9;padding:0 10px"
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <strong>EXÁMEN FÍSICO </strong>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </b-card-header>
        
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">

            <b-form-group label="Seleccionar examen físico: ">
              <b-form-checkbox-group
                :options="examenesFisicosOpts"
                plain
                size="lg"
                v-model="examenesFisicosChecked"
              />
            </b-form-group>

            <div
              v-for="(examenFisico) in examenesFisicosItems"
              :key="examenFisico.value"
              class="row my-2 d-flex align-items-center"
            >
              <div class="col-sm-3">
                <label>{{ examenFisico.text }}</label>
              </div>

              <div class="col-sm-8">

                <b-form-input
                  v-model="examenFisico.inputText"
                  placeholder="Describa el examen fisico..."
                  type="text"
                />
              </div>

            </div>

            <ExamenPediatria/>

            <div>
              <b-form-checkbox
                v-model="observaciones.active"
              >
                <label for="">Observaciones Adicionales:</label>
              </b-form-checkbox>

              <b-form-textarea
                v-if="observaciones.active"
                v-model="observaciones.text"
              />
            </div>


            <div>
              <hr>
              <p v-html="summaryText.html"/>
            </div>

            <b-form-group  class = "mt-1" >
              <b-button  
                @click="copyAS400()"
                variant = "info"
              >
                AS400  <i class="fas fa-copy"/>
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>

  

</template>

<script>

import axios                   from 'axios';
import rutas                   from '@/assets/utils/rutas.json';
import { addNewOpt, copyText } from '@/shared/helpers';
import { mapState }            from 'vuex';
import { anamnesisService }    from '@/views/atencionMedica/services/anamnesisService/anamnesisService';
import { ESPECIALIDAD }        from '@/shared/constants';
import ExamenPediatria         from './ExamenPediatria.vue';

export default {
  name: "ExamenFisico",
  
  components: {
    ExamenPediatria
  },

  data() {
    return {

      tokenAtencion: null,
      visibleBody:false,
      examenesFisicosOpts:[],
      examenesFisicosChecked:[],
      examenesFisicosItems:[],

      observaciones:{
        active: false,
        text: ''
      },

      itemsInicial: [],
      itemsToDelete: [],

      dataState:{
        itemsInicial: [],
        items: [],
        itemsToDelete: [],
        observaciones:{
          active: false,
          text: '',
        }
      },

    };
  },

  async created() {
    await this.getExamenesFisicosOpts();

    this.loadDataRegister();
  },

  methods:{


    async loadDataRegister(){
      this.tokenAtencion = this.$route.params.token;

      if(!this.tokenAtencion) return;

      const responseExamenFisico = await anamnesisService.getExamFisicosByAtencion(this.tokenAtencion);

      const { examenes, observaciones } = responseExamenFisico;

      const examenesCheck = examenes.map( ex => ex.examenfisico.descripcion.toLowerCase() );

      this.examenesFisicosChecked = [...new Set(examenesCheck)];

      if(observaciones) {
        this.observaciones.active = true;
        this.observaciones.text = observaciones;
      }

      examenes.forEach( ex => {
        this.examenesFisicosItems.push({
          idExamen : ex.id,
          id       : ex.examenfisico.id,
          value    : ex.examenfisico.descripcion.toLowerCase(),
          text     : ex.examenfisico.descripcion,
          inputText: ex.descripcionGeneral,
        });
      });


      this.itemsInicial = this.examenesFisicosItems.map( item => item.idExamen );

    },

    onVisibleBody(visible){
      this.visibleBody = visible
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    async getExamenesFisicosOpts() {
      const query = `
        query {
          allExafis {
            id, descripcion
          }
        }
      `;
      try {
        const response = await axios.post(`${rutas.axios}api`, { query });

        this.examenesFisicosOpts = response.data.data.allExafis.map( item => ({
          id: item.id,
          value: item.descripcion.toLowerCase(),
          text: item.descripcion
        }));
        
        return null;
        
      } catch (error) {
        console.error("Error fetching examenes fisicos:", error);
        return error;
      }
    },


    copyAS400() {
      copyText(this.summaryText.text);
    },



    getTextDataJson(data) {
      if(!data) return '';

      const textJson = [];

      if(data.tipo === 'pediatria'){
        if(data.testDenver) textJson.push(`(Test Denver) ${data.testDenver}`);

        if(data.exploracionItems.length)
          data.exploracionItems.forEach( item => {
            textJson.push(`${item.text}: ${item.presente ? 'Presente' : 'Ausente'} ${item.inputText}`);
          });
      }

      return textJson.join(', ');
    },
  },

  computed: {
    ...mapState({
      stExamenFisico: state => state.atencionCita.anamnesis.examenFisico,
      stDataDoctor  : state => state.atencionCita.dataCita?.doctor,
    }),



    summaryText() {
      

      const items = this.stExamenFisico?.items || [];

      const textArray = this.examenesFisicosOpts.map( o => {
        const item = items.find( i => i.id === o.id );
        if(!item) return `${o.id}. ${o.text}: NO PATOLOGICO`;

        const textDataJson = item.dataJson 
          ? this.getTextDataJson(item.dataJson) 
          : '';

        return `${o.id}. ${o.text}: ${item.inputText} ${textDataJson}`;
      })

      textArray.unshift("Revision de Organos y Sistemas: ");

      if (this.observaciones.active && this.observaciones.text.trim() !== '')
        textArray.push(`${this.observaciones.text}`);

      const textFinish = {
        html:textArray.join('<br>'),
        text: textArray.join('\n')
      }

      return textFinish;
    },


    esPediatria() {
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.PEDIATRA;
    }
  },



  watch: {

    examenesFisicosChecked: {
      deep: true,
      handler() {

        this.examenesFisicosItems = this.examenesFisicosItems.filter(
          item => this.examenesFisicosChecked.includes( item.value )
        );

        this.examenesFisicosChecked.forEach( id => {
          if(!this.examenesFisicosItems.some( item => item.value === id)){
            const newItem = this.examenesFisicosOpts.find( item => item.value === id );

            this.examenesFisicosItems.push({
              id: newItem.id || null,
              value: newItem.value,
              text: newItem.text,
              inputText: '',
              dataJson: ''
            });
          }
        });

      }
    },

    examenesFisicosItems: {
      deep: true,
      handler(newValue) {
        const newItems = newValue.map( item => {
          if(!item.checked) return {
            ...item, 
          };

          return item
        })
        this.dataState.items = newItems;

        this.itemsToDelete = this.itemsInicial.filter( item => !newItems.some( newItem => newItem.idExamen === item ));
      }
    },

    observaciones: {
      deep: true,
      handler(newValue) {
        if(!newValue.active) this.observaciones.text = '';
        this.dataState.observaciones = newValue
      }
    },

    itemsInicial: {
      deep: true,
      handler(newValue) {
        this.dataState.itemsInicial = newValue
      },
    },

    itemsToDelete: {
      deep: true,
      handler(newValue) {
        this.dataState.itemsToDelete = newValue
      },
    },

    dataState: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setExamenFisico", newValue);
      },
    },

  },


}
</script>

<style>

  .form-check{
    width: 45%;
  }

</style>
